import { analytics } from "@/config/analytics";
import { env } from "@/env";
import { Button, icons } from "@/ui";
import { addUtmParams } from "@/utils/url";

type CheckoutButtonProps = {
  checkoutUrl: string;
  disabled: boolean;
  /** The monthly total shown at the right end of the pill. */
  amountAsString?: string | null;
  /** Every product removed: the pill stays, disabled, and says so. */
  isEmpty?: boolean;
};

const PILL_CLASS_NAME = "w-full justify-between px-6";

export const CheckoutButton = ({
  amountAsString,
  checkoutUrl,
  disabled,
  isEmpty = false,
}: CheckoutButtonProps) => {
  const renderAmount = () => {
    if (isEmpty) {
      return <span className="text-base whitespace-nowrap">Nothing in your order</span>;
    }

    if (!amountAsString) {
      return null;
    }

    return <span>{`$${amountAsString}/mo`}</span>;
  };

  const content = (
    <>
      <span className="flex items-center gap-2 whitespace-nowrap">
        <icons.LockIcon aria-hidden="true" className="size-4" />
        <span>Check Out</span>
      </span>
      {renderAmount()}
    </>
  );

  if (disabled) {
    return (
      <Button className={PILL_CLASS_NAME} size="lg" disabled>
        {content}
      </Button>
    );
  }

  const checkoutUrlWithUtm = addUtmParams(checkoutUrl, {
    utm_source: new URL(env.VITE_APP_URL).hostname,
    utm_medium: "referral",
  });

  return (
    <Button className={PILL_CLASS_NAME} size="lg" asChild>
      <a
        href={checkoutUrlWithUtm}
        onClick={() => {
          return analytics.track("cart_checkout_started");
        }}
        rel="noopener noreferrer"
        target="_blank"
      >
        {content}
      </a>
    </Button>
  );
};
